(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types'), require('lodash.debounce')) :
	typeof define === 'function' && define.amd ? define(['react', 'prop-types', 'lodash.debounce'], factory) :
	(global.reactBottomScrollListener = factory(global.React,global.PropTypes,global.debounce));
}(this, (function (React,PropTypes,debounce) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;
PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
debounce = debounce && debounce.hasOwnProperty('default') ? debounce['default'] : debounce;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var BottomScrollListener = function (_Component) {
  inherits(BottomScrollListener, _Component);

  function BottomScrollListener(props) {
    classCallCheck(this, BottomScrollListener);

    var _this = possibleConstructorReturn(this, (BottomScrollListener.__proto__ || Object.getPrototypeOf(BottomScrollListener)).call(this, props));

    if (props.debounce) {
      _this.handleOnScroll = debounce(_this.handleOnScroll.bind(_this), props.debounce, { trailing: true });
    } else {
      _this.handleOnScroll = _this.handleOnScroll.bind(_this);
    }
    return _this;
  }

  createClass(BottomScrollListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('scroll', this.handleOnScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.handleOnScroll);
    }
  }, {
    key: 'handleOnScroll',
    value: function handleOnScroll() {
      var scrollNode = document.scrollingElement || document.documentElement;

      if (scrollNode.scrollHeight - this.props.offset <= scrollNode.scrollTop + window.innerHeight) {
        this.props.onBottom();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return !this.props.children ? null : React__default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);
  return BottomScrollListener;
}(React.Component);

BottomScrollListener.defaultProps = {
  debounce: 200,
  offset: 0,
  children: null
};

BottomScrollListener.propTypes = {
  onBottom: PropTypes.func.isRequired,
  debounce: PropTypes.number,
  offset: PropTypes.number,
  children: PropTypes.element
};

return BottomScrollListener;

})));



//////////////////
// WEBPACK FOOTER
// ./~/react-bottom-scroll-listener/dist/react-bottom-scroll-listener.umd.js
// module id = 473
// module chunks = 0